import { createContext } from "react";
import { IContext } from "./stepNavigation.types";

export const Context = createContext<IContext | undefined>(undefined);
